import { NavLeft } from "framework7-react";

export function NavLeftEmpty() {
  return (
    <NavLeft>
      <a className="icon-only" />
    </NavLeft>
  );
}
